import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()({
  indicator: {
    position: 'absolute',
    width: '100%',
    height: '2px',
    backgroundColor: 'red',
    zIndex: 2,
    pointerEvents: 'none',
  },
})
